export enum LoanPrograms {
  DEFAULT = "30yr fixed",
  FIVE_ARM = "5/1 ARM",
  FIVE_SIX_THIRTY_DAY_SOFR_ARM = "5/6 30-Day SOFR ARM",
  SEVEN_ARM = "7/1 ARM",
  SEVEN_SIX_THIRTY_DAY_SOFR_ARM = "7/6 30-Day SOFR ARM",
  TEN_ARM = "10/1 ARM",
  TEN_SIX_THIRTY_DAY_SOFR_ARM = "10/6 30-Day SOFR ARM",
  THIRTY_YEAR = "30yr fixed",
}

// for ordering dropdowns (and so on) coherently, instead of alphabetizing:
// - most common/vanilla programs first
// - then group programs with similar bases (LIBOR, SOFR)
// - and order grouped programs by time to float
export const orderedLoanPrograms = [
  LoanPrograms.THIRTY_YEAR,
  LoanPrograms.FIVE_ARM,
  LoanPrograms.SEVEN_ARM,
  LoanPrograms.TEN_ARM,
  LoanPrograms.FIVE_SIX_THIRTY_DAY_SOFR_ARM,
  LoanPrograms.SEVEN_SIX_THIRTY_DAY_SOFR_ARM,
  LoanPrograms.TEN_SIX_THIRTY_DAY_SOFR_ARM,
];

export const humanizeLoanProgramName = {
  [LoanPrograms.FIVE_ARM]: "5/1 LIBOR ARM",
  [LoanPrograms.FIVE_SIX_THIRTY_DAY_SOFR_ARM]: "5/6 SOFR ARM",
  [LoanPrograms.SEVEN_ARM]: "7/1 LIBOR ARM",
  [LoanPrograms.SEVEN_SIX_THIRTY_DAY_SOFR_ARM]: "7/6 SOFR ARM",
  [LoanPrograms.TEN_ARM]: "10/1 LIBOR ARM",
  [LoanPrograms.TEN_SIX_THIRTY_DAY_SOFR_ARM]: "10/6 SOFR ARM",
  [LoanPrograms.THIRTY_YEAR]: "30-year fixed",
};

export const operatorHumanizeLoanProgramName = {
  [LoanPrograms.FIVE_ARM]: "5/1 LIBOR ARM",
  [LoanPrograms.FIVE_SIX_THIRTY_DAY_SOFR_ARM]: "5/6 30-Day SOFR ARM",
  [LoanPrograms.SEVEN_ARM]: "7/1 LIBOR ARM",
  [LoanPrograms.SEVEN_SIX_THIRTY_DAY_SOFR_ARM]: "7/6 30-Day SOFR ARM",
  [LoanPrograms.TEN_ARM]: "10/1 LIBOR ARM",
  [LoanPrograms.TEN_SIX_THIRTY_DAY_SOFR_ARM]: "10/6 30-Day SOFR ARM",
  [LoanPrograms.THIRTY_YEAR]: "30-year fixed",
};

export enum LoanTypes {
  CONFORMING = "conforming",
  JUMBO = "jumbo",
  HIGH_BALANCE = "high_balance",
  JUMBO_LOW_DOWNPAYMENT = "jumbo_low_downpayment",
  VA_CONFORMING = "va_conforming",
  VA_HIGH_BALANCE = "va_high_balance",
  INVESTMENT_CONFORMING = "investment_conforming",
  INVESTMENT_JUMBO = "investment_jumbo",
  INVESTMENT_HIGH_BALANCE = "investment_high_balance",
}

export const humanizeLoanTypeName = {
  [LoanTypes.CONFORMING]: "Conforming",
  [LoanTypes.JUMBO]: "Jumbo",
  [LoanTypes.HIGH_BALANCE]: "High-balance",
  [LoanTypes.JUMBO_LOW_DOWNPAYMENT]: "Jumbo Low-Downpayment",
  [LoanTypes.VA_CONFORMING]: "VA Conforming",
  [LoanTypes.VA_HIGH_BALANCE]: "VA High-balance",
  [LoanTypes.INVESTMENT_CONFORMING]: "Investment Conforming",
  [LoanTypes.INVESTMENT_JUMBO]: "Investment Jumbo",
  [LoanTypes.INVESTMENT_HIGH_BALANCE]: "Investment High-balance",
};

export const loanTypeToShortName = (t: string): string => {
  const isVa = [LoanTypes.VA_CONFORMING, LoanTypes.VA_HIGH_BALANCE].includes(t as LoanTypes);
  return isVa ? "VA" : "Conventional";
};

export enum LoanMilestone {
  ApplicationStarted = "application_started",
  CreditReportReceived = "credit_report_received",
  PreApplication = "pre_application",
  RESPA = "respa",
  Closing = "closing",
  PostClosing = "post_closing",
}

export const humanizeLoanMilestoneName = {
  [LoanMilestone.ApplicationStarted]: "Application started",
  [LoanMilestone.CreditReportReceived]: "Credit report received",
  [LoanMilestone.PreApplication]: "Pre-application",
  [LoanMilestone.RESPA]: "RESPA",
  [LoanMilestone.Closing]: "Closing",
  [LoanMilestone.PostClosing]: "Post-closing",
};

export const orderedLoanMilestones = [
  LoanMilestone.ApplicationStarted,
  LoanMilestone.CreditReportReceived,
  LoanMilestone.PreApplication,
  LoanMilestone.RESPA,
  LoanMilestone.Closing,
  LoanMilestone.PostClosing,
];
